<div *ngIf="true" [ngClass]="{ 'commitment-type-container' : serviceOrderType.serviceTypeEnumValue !== ServiceTypeEnum.COORDINATION_TRANSPORT && serviceOrderType.serviceTypeEnumValue !== ServiceTypeEnum.MAJOR_INCIDENT }" >
  <app-drop-down-with-hover [disabled]="readOnlyMode" [requiredRedBackground]="true" [name]="'sub-commitment-type-name' | translate" [items]="commitmentTypes"
    [(selectedItem)]="commitmentType"  (selectedItemChange)="commitmentTypeChanged($event)">
  </app-drop-down-with-hover>
</div>
